import { IAudit } from '../../../../app/entities/Audit'
import { AUDIT_PROGRESS } from '../constants/audit'

function isAuditPassing(audit: IAudit): boolean {
  const auditIsCompleted = audit.progress === AUDIT_PROGRESS.completed
  if (auditIsCompleted) return true
  const auditIsCoached = audit.progress === AUDIT_PROGRESS.coached
  if (auditIsCoached) {
    const auditDoesNotNeedCoaching = audit.state
      ? Object.values(audit.state).every(
          (section) => section.coaching?.needsCoaching === false,
        )
      : true
    return auditDoesNotNeedCoaching
  } else {
    return false
  }
}

export default isAuditPassing
